/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">

    </titleInfo>
    <div class="more" @click="getmore()">
      <i class="el-icon-s-unfold"></i>
      <span>更多</span>
    </div>
    <div class="itemBodyMain scrollBar">
      <div v-for="(item,index) in riskList" :key="index">
        <div class="itemBodyMainItem" >
          <div class="time">{{ item.createTime }}</div>
            <div class="name">{{ item.deptNameLink.join(',')  }}</div>
          <div class="info">{{ item.simpleMess }}</div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import message from "@/components/home/item6/message";
import callPolice from "@/components/home/item6/callPolice";
import Axios from "@/utils/Axios";
import tab from "./components/tab";
import Bus from "@/utils/bus.js";

export default {
  name: "index",
  components: {titleInfo, message, callPolice,tab},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      riskList:[

      ],
      active: 0,
      tablist: [{
        name: '更多',
        id: 0,
      }],
      status: '',
      list:
        []
    }
  },
  watch: {},
  mounted() {
    this.initWebSocket();
    this.queryRealtimeList()



  },
  methods: {
    getmore(){
      Bus.$emit('opentc','risk')
    },
    // 初始化一个 websocket 对象，同时给基本属性赋值
    initWebSocket: function () {

      var token = sessionStorage.getItem("token");

      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https，此处传入需要跟后台连接的接口路径
      //this.websock = new WebSocket( "ws://124.70.202.197/websocket/risk?authorization=" + token); //正式服
      this.websock = new WebSocket("wss://www.wha518.com/websocket/risk?authorization=" + token);//测试服

      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      // this.websock.onclose = this.websocketclose;
    },
    // 定义 websocket open属性的函数
    websocketonopen: function () {
      // this.websock.send(token)
      console.log("WebSocket连接成功risk666");
    },
    // 定义 websocket onerror属性的函数
    websocketonerror: function (e) {
      console.log("WebSocket连接发生错误");
    },
    // 定义 websocket onmessage属性的函数
    websocketonmessage: function (e) {

      let that = this;
      let mess = e.data;


      // let messsdata = JSON.parse(mess);
      let messsdata = eval("("+mess+")");


      messsdata.createTime= that.formatDate(messsdata.createTime)

      that.riskList.pop()
      that.riskList.unshift(messsdata)


    },
    formatDate (d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
      var ss =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },

    websocketclose: function (e) {
      console.log("connection closed");
    },
    queryRealtimeList() {
      const param = {
        url: "/portal/lastRisks",
        method: "post",
        data: {

        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {

          this.riskList = res.data;

        }

      });
    },
    setdata(){
      let data= "{alertLevel:0,createTime:2022-09-09T17:04:07,deptId:15,deptNameLink:[浙大滨江研究院],simpleMess:设备新装}"
      let messsdata = eval("("+data+")");
      console.log(messsdata)
    },
    getHide() {
      this.$emit('getHide', 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 650px;
  height: 100%;
  z-index: 1000;
  .more{
    width: 50px;
    height: 24px;
    border: 1px solid #4472cb;
    position: absolute;
    top: 8px;
    right: 30px;
    background: url("../../../assets/home/tabbg.png");
    background-size: 100% 100%;
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #46BCFF;
    opacity: 1;
    cursor: pointer;
    z-index: 1000;
  }
  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);
    overflow: scroll;
    z-index: 100;
    .itemBodyMainItem {
      width: calc(100% - 30px);
      background: url("../../../assets/home/item6bg1.png") no-repeat;
      height: 36px;
      background-size: 100% 100%;
      margin-left: 10px;
      margin-right: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .time {
        padding-left: 54px;
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        line-height: 14px;
        text-shadow: 0px 1px 1px rgba(3, 21, 110, 0.3);
      }

      .name {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        margin-left: 20px;
      }

      .info {
        font-size: 16px;
        font-family: PingFang;
        font-weight: bold;
        color: #01A3FF;
        opacity: 0.8;
        margin-left: 20px;
      }

      .desc {
        color: rgba(202, 234, 255, 1);
        font-size: 16px;
        font-family: PingFang;
        font-weight: bold;
        margin-left: 5px;
      }
    }

    .itemBodyMainItem.type1 {
      background: url("../../../assets/home/item6bg2.png") no-repeat;
      background-size: 100% 100%;

      .info {
        color: #b4a02e;
      }
    }

    .itemBodyMainItem.type2 {
      background: url("../../../assets/home/item6bg3.png") no-repeat;
      background-size: 100% 100%;

      .info {
        color: #b8554c;
      }
    }
  }
}

</style>
